<template>
  <div>
    <div class="flex justify-between mb-1" v-if="label">
      <label class="block text-sm font-medium leading-5 text-gray-700">{{
        label
      }}</label>
      <span class="text-sm leading-5 text-gray-500" v-if="required">
        {{ $t ? $t('sqrd_ui_required') : 'Required' }}
      </span>
    </div>

    <div class="flex rounded-md shadow-sm">
      <input
        class="flex-1 block w-full px-3 py-2 rounded-none rounded-l-md rounded-r-none sm:text-sm sm:leading-5 border border-gray-300 transition duration-150 ease-in-out;"
        v-bind="$attrs"
        v-on="sqrListeners"
        @change="process('change', $event)"
        @input="process('input', $event)"
        :class="inputClass"
        type="text"
        :value="percent"
        :placeholder="placeholder || label"
      />
      <span
        class="inline-flex items-center px-3 rounded-r-md border border-l-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm"
      >
        %
      </span>
    </div>

    <slot name="invalid" v-if="v && v.$error">
      <p
        class="mt-1 text-xs text-red-600"
        v-if="v.$params.required && !v.required"
      >
        {{ label }} is required.
      </p>
      <p
        class="mt-1 text-xs text-red-600"
        v-if="v.$params.maxLength && !v.maxLength"
      >
        {{ label }} is too long (max {{ v.$params.maxLength.max }} chars).
      </p>
    </slot>
  </div>
</template>

<script>
import SqrInput from './SqrInput';
export default {
  name: 'SqrdInputPercent',
  mixins: [SqrInput],
  props: {
    value: Number,
  },
  computed: {
    percent() {
      return (this.value ?? 0) * 100.0;
    },
  },
  methods: {
    process(name, event) {
      const percent = parseFloat(event.target.value);
      if (isNaN(percent)) {
        this.$emit(name, '');
      } else {
        this.$emit(name, percent / 100.0);
      }
    },
  },
};
</script>
